import { api_url } from "../../../utils";

const RutasBus = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=tpub&schema_city=",
    zindex: 2,
    type: "categorized",
    popup: {
        default: {
            content: {
                es: {
                    linename: "Número de la línea de bus: ",
                    intervalo: "Intervalo en hora punta: ",
                    velocidad: "Volocidad comercial (km/h): ",
                    direccion: "",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.RutasBus",
    style: {
        regular: false,
        fillColor: "rgb(255, 158, 23)",
        strokeColor: "rgb(255, 158, 23)",
        strokeWidth: 0,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.RutasBus.title",
            subtitle: "",
            attribute: "direccion",
            symbol: "line",
            legendCustomCssClass: "",
            class: [
                {
                    fillColor: "rgb(8, 107, 204)",
                    strokeColor: "rgb(8, 107, 204)",
                    strokeWidth: 2,
                    value: "ida",
                    label: "Mobility Indicators Content.layersLegend.RutasBus.classes.1",
                },
                {
                    fillColor: "rgb(8, 107, 204)",
                    strokeColor: "rgb(8, 107, 204)",
                    strokeWidth: 2,
                    strokeLineDash: [2, 4],
                    value: "retorno",
                    label: "Mobility Indicators Content.layersLegend.RutasBus.classes.2",
                    customCssClass:
                        "map-legend-symbol-line-dotted-3px-no-background-8-107-204",
                },
            ],
        },
    },
};

export default RutasBus;
